.root {
  align-items: center;
  background: var(--color-background);
  border-bottom: 1px solid var(--color-border);
  display: none;
  height: 56px;
  justify-content: space-between;
  padding: 0 16px;
}

.menuBtn {
  align-items: center;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: center;
  width: 36px;

  &:hover {
    background: var(--color-secondary);
  }
}

.menuIcon {
  color: var(--color-foreground);
  height: 24px;
  width: 24px;
}

.actions {
  align-items: center;
  display: flex;
  gap: 4px;
}

// Matches .menuBtn's 36px box so the right-hand controls line up.
.headerControl {
  height: 36px;
  width: 36px;
}

.brand {
  height: auto;
  max-height: 36px;
  max-width: 160px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .root {
    display: flex;
  }
}
